import Navbar from "../components/Navbar";
import Chapter3thongtin from "./Chapter3thongtin";
function Chapter3(){
    return(
        <>
        <Navbar/>
        <Chapter3thongtin/>
        </>
    )
}
export default Chapter3;